import { useState } from "react";
import Alert from "react-bootstrap/Alert";
import { useDispatch, useSelector } from "react-redux";

import { setSettings } from "store/settings";

const AlertDismissible = () => {
  const dispatch = useDispatch();
  const seenWarningSept2023 = useSelector((state) => state.settings.seenWarningSept2023);
  const [show, setShow] = useState(!seenWarningSept2023);

  const onClose = () => {
    setShow(false);
    dispatch(setSettings({ seenWarningSept2023: true }));
  };

  return (
    show && (
      <div className="mb-3 mx-3">
        <Alert dismissible onClose={onClose} variant="warning">
          Salt voting 2023 is live! (9/26 - 9/28) <a href="/salt">Take me to the mines</a>
        </Alert>
      </div>
    )
  );
};

export default AlertDismissible;
